import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const PlusCircle: React.FC<IconProps> = ({
  color = '#fff',
  size = 24,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M11 11V8a1 1 0 112 0v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H8a1 1 0 110-2h3zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
      fill={color}
    />
  </svg>
)
